
import {createAsyncThunk, createSlice, current} from '@reduxjs/toolkit';

const initialState = {
    rechargeUserInfo: ""
};

export const teacherManagerSlice = createSlice({
    name: 'teacherManager',
    initialState,
    reducers: {
        setRechargeUserInfo: (state,action) => {
            state.rechargeUserInfo = action.payload;
        }
    },
});

export const selectRechargeUserInfo = (state) => state.teacherManager.rechargeUserInfo;
export const {
    setRechargeUserInfo
} = teacherManagerSlice.actions;

export default teacherManagerSlice.reducer;
